import { IPullRequest } from './../interfaces/azuredevops/pullrequest.interface';
import { IBuild, IBuildDetails } from './../interfaces/azuredevops/build.interface';
import { environment } from './../../../environments/environment';
import { Injectable } from "@angular/core";
import {  filter, from, map, mergeMap, Observable, tap, toArray, of, merge, switchMap, forkJoin} from "rxjs";
import {  HttpClient } from "@angular/common/http";
import { IAzureDevopsRepository, IAzureDevopsRepositoryResponse } from '../interfaces/azuredevops/repository.interface';
import { Cacheable } from 'ts-cacheable';

@Injectable({
    providedIn: "root"
})
export default class AzureDevopsService {

    constructor(private httpClient:HttpClient){}    

    private hasPulumi = [
        "NiboAccountant",
        "NiboAccountantLegacy",
        "NiboOrganization",
        "NiboOrganizationLegacy",
        "NiboFileApi"
    ]     
    
    @Cacheable({
        slidingExpiration: true,
        maxAge: 600000
    })
    public getRepositories(): Observable<IAzureDevopsRepository[]> {        
        return this.httpClient.get<IAzureDevopsRepositoryResponse>("https://dev.azure.com/nibogestao/niboprojects/_apis/git/repositories?api-version=4.1", {           
        }).pipe(             
            map((repositories) => {
                return repositories.value.filter(repository => this.hasPulumi.indexOf(repository.name) != -1)
            })
        )
    }   

    public getPullRequestInformations(repositoryId: string, pullRequestId?: number): Observable<IPullRequest> {
        return this.httpClient.get<IPullRequest>(`https://dev.azure.com/${environment.azureDevops.organization}/${environment.azureDevops.principalProject}/_apis/git/repositories/${repositoryId}/pullrequests/${pullRequestId}?api-version=6.0`)
    }

    public getBuildsInformations(repositoryId: string, env: string): Observable<any>{
        return this.httpClient.get<IBuild>(`https://dev.azure.com/${environment.azureDevops.organization}/${environment.azureDevops.principalProject}/_apis/build/builds?api-version=6.0&repositoryId=${repositoryId}&tagFilters=${env}&$top=50&queryOrder=finishTimeDescending&repositoryType=TfsGit`)        
        .pipe(
            mergeMap((res: IBuild) => from(res.value)),
            mergeMap((build: IBuildDetails) => {
                if(build.triggerInfo['pr.number'] != undefined) {
                    return this.getPullRequestInformations(environment.azureDevops.organizationWebRepositoryId, Number(build.triggerInfo['pr.number'])).pipe(
                    map<{[key: string]: any}, IBuildDetails>((res) => ({...build, pullRequestTitle: res['title']})))
                }
                else {
                    return from([build])
                }
            }),  
            filter((build) => build.retainedByRelease === true),
            toArray()
        )
           
    }
    
}